module.exports = __webpack_public_path__ + "img/1.11d115a6.png";